import { grid } from '@squareup/dex-ui-shared-markdown-components';
import React, { FC, PropsWithChildren } from 'react';

interface MdxGridProps {
  dataName?: string;
}

const GridComponent = grid.component.value as FC<
  PropsWithChildren<MdxGridProps>
>;

const MdxGrid: FC<PropsWithChildren<MdxGridProps>> = ({
  children,
  ...props
}) => {
  return <GridComponent {...props}>{children}</GridComponent>;
};

MdxGrid.displayName = 'MdxGrid';

export { MdxGrid };
